// extracted by mini-css-extract-plugin
export default {"panelText":"PanelText_panelText__+Gm79","panelTextM":"PanelText_panelTextM__kgLR2"};